
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerEditor()
    export class PoPurRequestAppEditors extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, PoPurRequestAppRow>{

        constructor(hidden: JQuery) {
            super(hidden);
        }

        protected getLookupKey() {
            return PoPurRequestAppRow.lookupKey;
        }

        // protected getItemText(item, lookup) {
        //     return super.getItemText(item, lookup) + ' [' + item.MbFirstName+']';
        // }
    }
}
